import { BaseModel } from '@d-models/other/http.model';

export enum REFERENCE_TYPES {
  INHOUSE_PRODUCT = 'INHOUSE_PRODUCT',
  MERCHANT_BUSINESS_PROFILE_PREFERRED_TELCO_SERVICE = 'MERCHANT_BUSINESS_PROFILE_PREFERRED_TELCO_SERVICE',
  MERCHANT_BUSINESS_PROFILE_SIZE_OF_STORE = 'MERCHANT_BUSINESS_PROFILE_SIZE_OF_STORE',
  MERCHANT_BUSINESS_PROFILE_TYPE_OF_GOODS = 'MERCHANT_BUSINESS_PROFILE_TYPE_OF_GOODS',
  MERCHANT_BUSINESS_PROFILE_TYPE_OF_PREMISE = 'MERCHANT_BUSINESS_PROFILE_TYPE_OF_PREMISE',
  MERCHANT_COMPANY_PROFILE_TYPE = 'MERCHANT_COMPANY_PROFILE_TYPE',
  MERCHANT_COMPANY_PROFILE_TYPE_OF_BUSINESS = 'MERCHANT_COMPANY_PROFILE_TYPE_OF_BUSINESS',
  MERCHANT_BUSINESS_RISK = 'MERCHANT_BUSINESS_RISK',
  MERCHANT_SCORE_CARD_KYC_FLAG = 'MERCHANT_SCORE_CARD_KYC_FLAG',
  BANK_NAME = 'BANK_NAME',
  COUNTRY = 'COUNTRY',
  STATES = 'STATES',
  MERCHANT_ERP_ACCOUNT_VENDOR_PAYMENT_TERM_FLAG = 'MERCHANT_ERP_ACCOUNT_VENDOR_PAYMENT_TERM_FLAG',
  MERCHANT_ERP_ACCOUNT_CUSTOMER_PAYMENT_TERM_FLAG = 'MERCHANT_ERP_ACCOUNT_CUSTOMER_PAYMENT_TERM_FLAG',
  SETTLEMENT_SETTING_PAYMENT_METHOD = 'SETTLEMENT_SETTING_PAYMENT_METHOD',
}

export interface IReferenceData {
  id: string;
  dataType: REFERENCE_TYPES;
  dataCode: string;
  dataValue: string;
  languageId: string;
  priority?: number;
  isBuiltin?: boolean;
  code?: string;
  // generated from database
  createdBy?: any;
  updatedBy?: any;
  createdDateTime?: any;
  updatedDateTime?: any;
  updatedUtcDateTime?: any;
}

export class ReferenceDataModel extends BaseModel {
  id: string;
  dataType: string;
  dataCode: string;
  dataValue: string;
  languageId: string;
  priority?: number;
  isBuiltin?: boolean;
  code?: string;

  // generated from database
  createdBy?: any;
  updatedBy?: any;
  createdDateTime?: any;
  updatedDateTime?: any;
  updatedUtcDateTime?: any;

  constructor(data: IReferenceData) {
    super(data);
    this.id = data.id;
    this.dataType = data.dataType;
    this.dataCode = data.dataCode;
    this.dataValue = data.dataValue;
    this.languageId = data.languageId;
    this.priority = data.priority;
    this.isBuiltin = data.isBuiltin;
    this.code = this.code;

    this.createdBy = data.createdBy;
    this.createdDateTime = data.createdDateTime;
    this.updatedDateTime = data.updatedDateTime;
    this.updatedUtcDateTime = data.updatedUtcDateTime;
  }
}
